export default __webpack_public_path__ + "static/media/mar-gameboard-02.7e9cbb96.jpg";